export const namespace = 'preSOJobs/';

export const PreSOJobsGetters = {
  GET_PRE_SO_JOBS_COUNT: namespace + 'getPreSOJobsCount',
  GET_PRE_SO_JOBS: namespace + 'getPreSOJobs',
  GET_JOB_FOR_ASSIGNMENT: namespace + 'getJobForAssignment',
  GET_UNIT_PRE_SO_JOBS: namespace + 'getUnitPreSOJobs',
  GET_SHOW_PRE_SO_JOBS: namespace + 'getShowPreSOJobs'
};

export const PreSOJobsActions = {
  FETCH_PRE_SO_JOBS_COUNT: namespace + 'fetchPreSOJobsCount',
  FETCH_PRE_SO_JOBS: namespace + 'fetchPreSOJobs',
  FETCH_UNIT_PRE_SO_JOBS: namespace + 'fetchUnitPreSOJobs',
  ADD_PRE_SO_JOBS_TO_SO: namespace + 'addPreSOJobsToSO',
  UPDATE_PRE_SO_JOB_VIN: namespace + 'updatePreSOJobVin'
};

export const PreSOJobsMutations = {
  SET_PRE_SO_JOBS_COUNT: namespace + 'setPreSOJobsCount',
  SET_PRE_SO_JOBS: namespace + 'setPreSOJobs',
  SET_JOB_FOR_ASSIGNMENT: namespace + 'setJobForAssignment',
  SET_JOB_FOR_ASSIGNMENT_PROPERTY: namespace + 'setJobForAssignmentProperty',
  SET_UNIT_PRE_SO_JOBS: namespace + 'setUnitPreSOJobs',
  SET_JOB_PROPERTY: namespace + 'setJobProperty',
  SET_SHOW_PRE_SO_JOBS: namespace + 'setShowPreSOJobs',
  UPDATE_PRE_SO_JOB_VIN: namespace + 'updatePreSOJobVin'
};
